
<div class="block mx-auto my-48 max-w-448">
  <SitterAlertBanner v-if="serverError" :error="serverError" />
  <PoppinsCard>
    <FormHeader />
    <form id="sitter-sign-up-form" novalidate @submit.prevent="validateAll">
      <PoppinsAccountCreateFields
        ref="accountCreateFields"
        :requiredFields="requiredFields"
        :serverError="serverError"
        @input="handleAccountCreateInput"
        @resetServerError="resetServerError"
      />
      <PhoneField ref="phoneField" @input="handleInput" />
      <BirthDateFields ref="birthDateFields" @input="handleInput" />
      <GenderRadio ref="genderRadio" @input="handleInput" />
      <PoppinsTermsOfUse
        ref="termsOfUse"
        class="mb-24"
        terms-of-use-link="https://www.sittercity.com/terms"
        privacy-policy-link="https://www.sittercity.com/privacy"
        @input="handleInput"
      />
      <PoppinsButton
        id="formSubmit"
        :loading="loading"
        class="w-full"
        variant="primary"
        :value="'Submit'"
        size="medium"
        type="submit"
      />
    </form>
  </PoppinsCard>
  <PoppinsTrustAndSafety />
</div>
